import React from 'react';

import {LicenseeType} from "../../../../schema";
import {LightningBoltIcon, OfficeBuildingIcon, UserIcon} from "@heroicons/react/outline";
import Tag from "../../../../ui/Tag";

type Props = {
  limited: boolean
  className?: string
}

export default function AccessStatus({limited, className}: Props) {
  if (!limited) {
    return <></>;
  }
  return (
    <div className={className}>
      <div className="text-red border inline border-red rounded-md mt-0.5 px-3 py-0.5 text-sm"
                       style={{width: "fit-content"}}>Limited Access</div>
    </div>
  );
}
